// UI
import { Card } from "@/components/Card"
import { Heading } from "@/components/Typography"

// Icons
import { XIcon } from "@/lib/icons"

/**
 * StepFailedOverlay
 * @param param0
 * @returns
 */
export const StepFailedOverlay = ({
	title,
	message,
}: {
	title: string | undefined
	message?: string | null
}) => {
	// Template
	return (
		<div
			className="absolute inset-0 z-10 bg-gray-600 bg-opacity-50 p-5 text-center text-lg"
			data-testid="StepFailedOverlay"
		>
			<Card className="mx-auto max-w-md">
				<div className="space-y-4 text-center">
					{/** State */}
					<Heading
						as="h2"
						styleAs="h5"
						className="flex justify-center gap-2"
					>
						<div className="flex items-center">
							<XIcon
								aria-hidden="true"
								className="size-5 text-lg text-red-500"
							/>
						</div>
						{title}
					</Heading>

					{/** Show human readable message */}
					{message && <p className="text-gray-500">{message}</p>}
				</div>
			</Card>
		</div>
	)
}
